import React from "react";
import styled from "styled-components";
import Button from "../components/button";

const LoadMoreButton = styled(Button)`
  margin: 2rem auto 1rem;
`;

export function usePaginatedList(
  list,
  limit,
  filter = () => true,
  filterArg = undefined
) {
  const [filterArgument, setFilterArg] = React.useState(filterArg);
  const [newList, setNewList] = React.useState(
    list.filter((item) => filter(item, filterArgument)).slice(0, limit)
  );

  return [
    newList,
    ({ children }) =>
      newList.length >=
      list.filter((item) => filter(item, filterArgument)).length ? null : (
        <LoadMoreButton
          variant="outlined"
          onClick={() =>
            setNewList(
              list
                .filter((item) => filter(item, filterArgument))
                .slice(0, newList.length + limit)
            )
          }
        >
          {children}
        </LoadMoreButton>
      ),
    (newFilterArg) => {
      setFilterArg(newFilterArg);
      setNewList(
        list.filter((item) => filter(item, newFilterArg)).slice(0, limit)
      );
    },
  ];
}
